import { render } from "./ImageOptimizerPopup.vue?vue&type=template&id=32d94bfa&scoped=true"
import script from "./ImageOptimizerPopup.vue?vue&type=script&lang=js"
export * from "./ImageOptimizerPopup.vue?vue&type=script&lang=js"

import "./ImageOptimizerPopup.vue?vue&type=style&index=0&id=32d94bfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d94bfa"]])

export default __exports__